<div class="relative flex gap-x-2">
    <!-- SECTION -->
    <app-search-select
        [options]="sectionKeys"
        [placeholder]="translation.getText('general', 'section')"
        [cssClasses]="cssClasses"
        [selectedFieldValue]="activeSection"
        (selectionChange)="onFieldChange('section', $event)"
    />

    <!-- ROW -->
    <app-search-select
        [options]="rowKeys"
        [placeholder]="translation.getText('general', 'row')"
        [cssClasses]="cssClasses"
        [disabled]="!activeSection || is3DSection"
        [selectedFieldValue]="activeRow"
        (selectionChange)="onFieldChange('row', $event)"

    />

    <!-- SEAT -->
    <app-search-select
        [options]="seatKeys"
        [placeholder]="translation.getText('general', 'seat')"
        [cssClasses]="cssClasses"
        [disabled]="!activeRow || is3DSection"
        [selectedFieldValue]="activeSeat"
        (selectionChange)="onFieldChange('seat', $event)"
    />  

</div>